import { useContext, useEffect, useRef } from 'react';
import { MediaPlaybackControlsContext } from '../../context/MediaPlaybackControlsContext';

/**
 * This HOC is used to reset and load the media element when the recording url changes.
 * This is necessary because the media element will not load the new recording url on it's own.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const withRecordingUrlReset = Component => {
  return props => {
    const {
      pause,
      reset
    } = useContext(MediaPlaybackControlsContext);
    const currentRecordingUrl = useRef(props.recordingUrl);
    useEffect(() => {
      if (currentRecordingUrl.current !== props.recordingUrl) {
        currentRecordingUrl.current = props.recordingUrl;
        pause();
        reset();
      }
    }, [props.recordingUrl, pause, reset]);
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props));
  };
};